import { observe } from "../lib/beacon"
document.addEventListener("turbo:load", observe)
